import { SyntheticEvent } from 'react'

const stopPropagationHandler = (event: SyntheticEvent) => {
  event.stopPropagation()
}

export default stopPropagationHandler
